import config from "../../../config/config";
import {
    GOOGLE_STORE_LIST_REQUEST,
    GOOGLE_STORE_UPSERT_REQUEST,
    GOOGLE_STORE_INFO_REQUEST,
    GOOGLE_STORE_SORT_UPDATE_REQUEST
} from "../../constants/app/googleStoreConstants";
import {
    BaseResponse, MarketGoogleStoreProductInfoRequest,
    MarketGoogleStoreProductListRequest,
    MarketGoogleStoreProductListResponse, MarketGoogleStoreProductUpsertRequest,
    PerplayMarketApi
} from "../../models/src";
import marketGoogleStoreProductInfoResponse from "../../models/src/model/MarketGoogleStoreProductInfoResponse";
import { fork, takeEvery, all } from 'redux-saga/effects';

const api = new PerplayMarketApi(config.API_CLIENT);

function* googleStoreListRequestSaga(payload) {
    try {
        const requestData = new MarketGoogleStoreProductListRequest();
        requestData.page = payload.page;
        requestData.pageLength = payload.pageLength;
        requestData.listType = payload.listType;

        console.log("요청 데이터:", requestData);

        const res = yield api.apiPerplayMarketGoogleStoreProductListPost(
            {marketGoogleStoreProductListRequest: requestData},
            () => {},
        );

        const data = api.apiClient.deserialize(res, MarketGoogleStoreProductListResponse);

        if(data.resultCode !== 200){
            console.log(data);
            throw Error(`Error: ${data.resultCode}`);
        }

        if(payload.callback){
            payload.callback(data);
        }

    }catch (error){
        console.error(error);
        if(payload.error){
            payload.error(error);
        }
    }

}

function* googleStoreUpsertRequestSaga(payload) {
    try {
        const requestData = new MarketGoogleStoreProductUpsertRequest();
        requestData.dataType = payload.dataType;
        requestData.jsonData = payload.jsonData;

        console.log("googleStoreUpsertRequestSaga :");
        console.log(requestData);

        const res = yield api.apiPerplayMarketGoogleStoreProductUpsertPost(
            {marketGoogleStoreProductUpsertRequest: requestData},
            () => {},
        );

        const data = api.apiClient.deserialize(res, BaseResponse);

        if(data.resultCode !== 200){
            console.log(data);
            throw Error(`Error: ${data.resultCode}`);
        }

        if(payload.callback){
            payload.callback(data);
        }

    }catch (error){
        console.error(error);
        if(payload.error){
            payload.error(error);
        }
    }

}

function* googleStoreInfoRequestSaga(payload) {
    try {
        const requestData = new MarketGoogleStoreProductInfoRequest();
        requestData.productNo = payload.productNo;

        const res = yield api.apiPerplayMarketGoogleStoreProductInfoPost(
            {marketGoogleStoreProductInfoRequest: requestData},
            () => {},
        );

        const data = api.apiClient.deserialize(res, marketGoogleStoreProductInfoResponse);

        if(data.resultCode !== 200){
            console.log(data);
            throw Error(`Error: ${data.resultCode}`);
        }

        if(payload.callback){
            payload.callback(data);
        }

    }catch (error){
        console.error(error);
        if(payload.error){
            payload.error(error);
        }
    }

}

function* googleStoreSortUpdateRequestSaga(payload) {
    try {
        const requestData = new MarketGoogleStoreProductUpsertRequest();
        requestData.data = payload.data;

        const res = yield api.apiPerplayMarketGoogleStoreProductSortUpdatePost(
            {marketGoogleStoreProductSortUpdateRequest: requestData},
            () => {},
        );

        const data = api.apiClient.deserialize(res, BaseResponse);

        if(data.resultCode !== 200){
            console.log(data);
            throw Error(`Error: ${data.resultCode}`);
        }

        if(payload.callback){
            payload.callback(data);
        }

    }catch (error){
        console.error(error);
        if(payload.error){
            payload.error(error);
        }
    }

}

function* rootSaga() {
    yield all([
        takeEvery(GOOGLE_STORE_LIST_REQUEST, googleStoreListRequestSaga),
        takeEvery(GOOGLE_STORE_UPSERT_REQUEST, googleStoreUpsertRequestSaga),
        takeEvery(GOOGLE_STORE_INFO_REQUEST, googleStoreInfoRequestSaga),
        takeEvery(GOOGLE_STORE_SORT_UPDATE_REQUEST, googleStoreSortUpdateRequestSaga),
    ])
}

const googleStoreSagas = [fork(rootSaga)];
export default googleStoreSagas;